import { Box, Select, TextField, Typography } from '@material-ui/core'
import { KeyboardBackspaceSharp } from '@material-ui/icons'
import { darken } from 'polished'
import styled from 'styled-components'
import { Button } from 'common/atoms/Button/Button'

export const StyledSelect = styled(Select)<{ width?: string }>`
  background-color: ${props => props.theme.colors.bgPrimary};
  max-width: ${props => props.width ?? '5.4rem'};
  width: 100%;
  min-width: 5.4rem;
  color: ${props => darken(0.30, props.theme.colors.accent1)};
  
  && {
    /* color: ${props => darken(0.30, props.theme.colors.accent1)}; */
    padding-left: 1rem;
    display: flex;
    align-items: center;
    border: none;
  }
`
export const StyledFormWrapper = styled(Box)<{isDevice:boolean}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  padding: ${props => props.isDevice? 0 : '0 1.5rem'};
  background: ${props => props.isDevice? '' : props.theme.colors.supplementary};
  border-radius: 0 0 8px 8px;
`

export const StyledInputContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  color: ${props => props.theme.colors.accent};
  width: 100%;
`

export const StyledActionButton = styled(Button)<{ isDevice?: boolean; disabled: boolean }>`
  background-color: ${props => (props.disabled ? props.theme.colors.supplementary : props.theme.colors.primary)} !important;
  color: ${props => (props.disabled ? props.theme.colors.accent : props.theme.colors.bgPrimary)} !important;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  border: ${props => (props.disabled ? 'none' : 'inherit')};
  text-transform: uppercase;
  width: ${props => (props.isDevice ? '100%' : '16rem')};
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  &&:active {
    opacity: 0.7;
  }

  && {
    margin-bottom: 0;
  }
  margin-bottom: 0.75rem !important;
`

export const StyledCancleActionButton = styled(Button)<{ isDevice?: boolean }>`
  background-color: transparent;
  color: ${props => props.theme.colors.error} !important;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  text-transform: uppercase;
  width: ${props => (props.isDevice ? '100%' : '16rem')};
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointr')};
  &&:active {
    opacity: 0.7;
  }

  && {
    margin-bottom: 0;
  }
  margin-bottom: 0.75rem !important;
`

export const StyledSubmitButtonBoxForm = styled(Box)<{ isDevice?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: ${props => (props.isDevice ? "column" : "row")};
  justify-content: center;
`

export const StyledBox = styled(Box)`
  && {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
  }
`

export const StyledSalaryTextField = styled(TextField)`
  width: 10rem;
  background-color: ${props => props.theme.colors.bgPrimary};
`

export const StyledLabel = styled(Typography)<{ isDevice?: boolean }>`
  && {
    font-size: 1rem;
    font-feature-settings: 'clig' off, 'liga' off;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 27px */
    letter-spacing: 0.15px;
    color: ${props => props.theme.colors.accent1};
  }
`

export const StyledTitle = styled(Typography)`
  width: 100%;
  color: ${props => props.theme.colors.accent1};
  text-transform: uppercase;
  padding-bottom: 1.44rem;

  && {
    font-weight: bolder;
    display: flex !important;
    flex-direction: column;
    align-items: center !important;
    justify-content: center !important;
    font-size: 1.5rem !important;
  }

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    margin-top: 3.4rem;
    border: 1px solid ${props => props.theme.colors.accent};
  }
`

export const StyledPageBox = styled(Box)`
  background-color: ${props => props.theme.colors.supplementary};
  margin: 1rem auto;
  border-radius: 0.94rem;
  max-width: 95%;
  padding: 1.3rem;
`
export const StyledTitleBox = styled(Box)`
  color: ${props => props.theme.colors.accent1};
  display: flex;
  gap: 0.63rem;
  align-items: center;
  margin-bottom: 1.1rem;
  text-transform: uppercase;
  font-size: 1.25rem;
  cursor: pointer;
`

export const StyledButtonBox = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
`

export const StyledDialogMessage = styled(Typography)`
  font-size: 1rem;
  color: ${props => props.theme.colors.accent1};
`

export const StyledTitleWrapper = styled(Box)`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 1.125rem;
  position: relative;
  padding-top: 1.56rem;
  background: ${props => props.theme.colors.supplementary};
  border-radius: 8px 8px 0 0;
  flex-direction: column;

  && {
    ::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      margin-top: 2.19rem;
      border: none;
    }
  }
`

export const StyledPageTitle = styled(Box)`
  font-size: 2.5rem !important;
  font-weight: 700;
  line-height: 120%;
  color: ${props => props.theme.colors.accent1};
`

export const StyledSalaryMobileContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 0.9rem;
`
export const StyledPageWrapper = styled(Box)<{ isDevice?: boolean }>`
 width: ${props => props?.isDevice ? '96%' : '100%'};
 max-width: 77rem;
 margin: 0 auto;
`

export const ReversedKeyboardBackspace = styled(KeyboardBackspaceSharp)`
  && {
    transform: scaleX(-1);
  }
`
